import { render } from "./KappLogin.vue?vue&type=template&id=21bda120&scoped=true"
import script from "./KappLogin.vue?vue&type=script&lang=js"
export * from "./KappLogin.vue?vue&type=script&lang=js"

import "./KappLogin.vue?vue&type=style&index=0&id=21bda120&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bda120"]])

export default __exports__